import validate from "/app/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.0_@types+node@22.13.10_aws4fetch@1.0.20_db0@0.3.1_eslin_b45aeffdbdc61708c9f85b560887ec91/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}